import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

let globalLenis: Lenis | null = null;

export function getLenis(): Lenis | null {
  return globalLenis;
}

/**
 * 全局高性能平滑滚动组件（基于 Lenis 引擎）
 * 赋予整站类似 Apple / Linear 官网的物理惯性阻尼感与丝滑滚动体验
 */
export function SmoothScroll() {
  const { pathname, hash } = useLocation();
  const lenisRef = useRef<Lenis | null>(null);

  useEffect(() => {
    // 初始化 Lenis 平滑滚动引擎
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: "vertical",
      gestureOrientation: "vertical",
      smoothWheel: true,
      wheelMultiplier: 1.0,
      touchMultiplier: 1.2,
      infinite: false,
    });

    lenisRef.current = lenis;
    globalLenis = lenis;

    let rafId: number;
    function raf(time: number) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      globalLenis = null;
    };
  }, []);

  // 路由跳转时平滑重置滚动位置
  useEffect(() => {
    if (!hash && !window.location.hash) {
      lenisRef.current?.scrollTo(0, { immediate: true });
    }
  }, [pathname, hash]);

  return null;
}
